import { CatalogItemEntity } from "../ProductsAndCatalogItems/CatalogItemEntity"
import { EProductOrderModeType } from "../../Enum/EProductOrderModeType"
import { OrderCatalogProduct } from "./OrderCatalogProduct"

export class OrderCatalogItem extends OrderCatalogProduct {
  catalogItemEntityId: number

  catalogItemEntity: CatalogItemEntity

  constructor(data: Partial<OrderCatalogItem> = {}) {
    super(data)

    this.catalogItemEntityId = data.catalogItemEntityId ?? -1

    this.catalogItemEntity = new CatalogItemEntity(data.catalogItemEntity)
  }

  protected override getJsonFields(): string[] {
    return [...super.getJsonFields(), "catalogItemEntityId"]
  }

  needFulfillment(): boolean {
    return this.catalogItemEntity.catalogProductEntity.needFulfillment
  }

  getName() {
    return this.catalogItemEntity.catalogProductEntity.name
  }

  getImage() {
    return this.catalogItemEntity.catalogProductEntity.iconUrl
  }

  getProductOrderMode(): EProductOrderModeType {
    return this.catalogItemEntity.catalogProductEntity.productOrderMode
  }
}
